import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../assets/logo.png';

function Karsilama() {
  const navigate = useNavigate();

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh', 
      backgroundColor: '#f5f5f5',
      fontFamily: "'Helvetica Neue', sans-serif"
    }}>
      <img 
        src={Logo} 
        alt="UKBA Kasa Logo" 
        style={{ 
          width: 'min(400px, 74vw)', 
          height: 'min(400px, 74vw)', 
          cursor: 'pointer',
          boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2), 0 12px 40px rgba(0, 0, 0, 0.15)',
          borderRadius: '10px',
          transition: 'transform 0.3s ease'
        }} 
        onClick={() => navigate('/giris')}
        onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
      />
    </div>
  );
}

export default Karsilama;